// Assume these are not only popup layers, but also notification layers and maybe something else's layers

export const LAYER = {
    ADVANCED_PLAYER_MESSAGE: 'ADVANCED_PLAYER_MESSAGE',
    ADVANCED_PLAYER_MESSAGE_MODAL: 'ADVANCED_PLAYER_MESSAGE_MODAL',
    CARD: 'CARD',
    COMMON: 'COMMON',
    GDPRP: 'GDPRP', /* Total changes - GDPRP popup */
    COOKIE_REGULATION_POPUP: 'COOKIE_REGULATION_POPUP', /* Total changes - Cookies Regulation Popup */
    HIGH_PRIORITY: 'HIGH_PRIORITY',
    NOTIFICATION: 'NOTIFICATION',
    BONUS_LOW: 'BONUS_LOW',
    BONUS: 'BONUS',
    QUICK_DEPOSIT: 'QUICK_DEPOSIT',
    GAMES_INFO: 'GAMES_INFO',
    LIGHTBOX: 'LIGHTBOX',
    TIME_IS_FLYING: 'TIME_IS_FLYING',
    LOGIN: 'LOGIN',
    LOGIN_MESSAGES: 'LOGIN_MESSAGES',
    SESSION_VALIDATION: 'SESSION_VALIDATION',
    DATA_VERIFICATION: 'DATA_VERIFICATION',
    MULTIVIEW_BONUS_TC: 'MULTIVIEW_BONUS_TC',
    MULTIVIEW_BONUS: 'MULTIVIEW_BONUS'
};

// All known visibility layers. The lower the index, the lower the layer visually.
export const LAYERS_ORDER = [
    LAYER.CARD, // quick deposit popup
    LAYER.QUICK_DEPOSIT, // quick deposit popup
    LAYER.GAMES_INFO, // games info popup
    LAYER.ADVANCED_PLAYER_MESSAGE, // 31133 - ActionShowAdvancedDialogInfo
    LAYER.ADVANCED_PLAYER_MESSAGE_MODAL, // 31133 - ActionShowAdvancedDialogInfo {isModal:true}
    LAYER.MULTIVIEW_BONUS, // bonusmultiview
    LAYER.MULTIVIEW_BONUS_TC, // bonusmultiview: T&C popup from bonus details popup
    LAYER.COMMON, // all popups by default go here
    LAYER.BONUS_LOW, // notification bonus popups (usually with OK button)
    LAYER.BONUS, // 33005 - popups with confirmation, more important

    LAYER.NOTIFICATION, // "toast" notifications
    LAYER.LIGHTBOX, // popup with iframe in it for redirection calls
    LAYER.TIME_IS_FLYING,
    LAYER.LOGIN, // login popup
    LAYER.DATA_VERIFICATION, // dataVerificationStatus popup
    LAYER.SESSION_VALIDATION, // 2FA, FitToPlay, PIN verification
    LAYER.LOGIN_MESSAGES, // waiting messages after login
    LAYER.COOKIE_REGULATION_POPUP, /* Total changes - Cookies Regulation Popup */
    LAYER.GDPRP, /* Total changes - GDPRP popup */
    LAYER.HIGH_PRIORITY // legacy 'high priority' popups
];

// todo remove from `index` and make common actions that don't require this method
export const getLayerId = (layer = 0) =>
    Number.isFinite(layer)
        ? layer
        : LAYERS_ORDER.indexOf(layer) * 1000;

export const layersMeta = {
    [LAYER.CARD]: {
        disableNavigation: true,
        alwaysVisible: true,
        enableOverlay: false
    },
    [LAYER.GAMES_INFO]: {
        disableNavigation: true,
        alwaysVisible: true
    },
    [LAYER.ADVANCED_PLAYER_MESSAGE_MODAL]: {
        hideBelow: true
    },
    /* Total changes */
    [LAYER.GDPRP]: {
        hideBelow: true
    },
    [LAYER.COOKIE_REGULATION_POPUP]: {
        hideBelow: true
    },
    /* Total changes */
    [LAYER.HIGH_PRIORITY]: {
        hideBelow: true,
        disableNavigation: true // todo disableNavigation
        // todo order? FIFO or FILO
    },
    [LAYER.QUICK_DEPOSIT]: {
        alwaysVisible: true
    },
    [LAYER.MULTIVIEW_BONUS]: {
        alwaysVisible: true
    },
    [LAYER.MULTIVIEW_BONUS_TC]: {
        alwaysVisible: true
    }
};
